import React from 'react';

interface PrivacyPolicyProps {
  onBack?: () => void;
}

const PrivacyPolicy = ({ onBack }: PrivacyPolicyProps) => {
  return (
    <div style={{ 
      backgroundColor: '#ffffff', 
      minHeight: '100vh',
      padding: '2rem 0'
    }}>
      <div className="container">
        <div style={{ 
          maxWidth: '800px', 
          margin: '0 auto',
          padding: '2rem',
          backgroundColor: 'white',
          borderRadius: '1rem',
          boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)'
        }}>
          {/* Header */}
          <div style={{ textAlign: 'center', marginBottom: '3rem' }}>
            <h1 style={{ 
              fontSize: '2.5rem', 
              fontWeight: 'bold', 
              color: '#111827',
              marginBottom: '1rem'
            }}>
              Política de Privacidade
            </h1>
            <p style={{ color: '#6b7280', fontSize: '1rem' }}>
              Última atualização: Janeiro de 2024
            </p>
          </div>

          {/* Content */}
          <div style={{ lineHeight: '1.6', color: '#374151' }}>
            <section style={{ marginBottom: '2rem' }}>
              <h2 style={{ fontSize: '1.5rem', fontWeight: 'bold', color: '#111827', marginBottom: '1rem' }}>
                1. Informações que Coletamos
              </h2>
              <p style={{ marginBottom: '1rem' }}>
                A Beno coleta apenas as informações necessárias para fornecer nossos serviços de criação de sites para profissionais da saúde:
              </p>
              <ul style={{ marginLeft: '1.5rem', marginBottom: '1rem' }}>
                <li style={{ marginBottom: '0.5rem' }}>Nome e especialidade profissional</li>
                <li style={{ marginBottom: '0.5rem' }}>Informações de contato (telefone, WhatsApp)</li>
                <li style={{ marginBottom: '0.5rem' }}>Endereço da clínica ou consultório</li>
                <li style={{ marginBottom: '0.5rem' }}>Registro profissional (CRM, CRO, etc.)</li>
              </ul>
            </section>

            <section style={{ marginBottom: '2rem' }}>
              <h2 style={{ fontSize: '1.5rem', fontWeight: 'bold', color: '#111827', marginBottom: '1rem' }}>
                2. Como Usamos Suas Informações
              </h2>
              <p style={{ marginBottom: '1rem' }}>
                Utilizamos suas informações exclusivamente para:
              </p>
              <ul style={{ marginLeft: '1.5rem', marginBottom: '1rem' }}>
                <li style={{ marginBottom: '0.5rem' }}>Criar e personalizar seu site profissional</li>
                <li style={{ marginBottom: '0.5rem' }}>Melhorar nossos serviços de IA</li>
                <li style={{ marginBottom: '0.5rem' }}>Fornecer suporte técnico quando necessário</li>
                <li style={{ marginBottom: '0.5rem' }}>Cumprir obrigações legais e regulatórias</li>
              </ul>
            </section>

            <section style={{ marginBottom: '2rem' }}>
              <h2 style={{ fontSize: '1.5rem', fontWeight: 'bold', color: '#111827', marginBottom: '1rem' }}>
                3. Proteção de Dados
              </h2>
              <p style={{ marginBottom: '1rem' }}>
                A Beno implementa medidas técnicas e organizacionais apropriadas para proteger suas informações pessoais contra acesso não autorizado, alteração, divulgação ou destruição.
              </p>
              <p style={{ marginBottom: '1rem' }}>
                Estamos em conformidade com a Lei Geral de Proteção de Dados (LGPD) e as diretrizes do Conselho Federal de Medicina (CFM).
              </p>
            </section>

            <section style={{ marginBottom: '2rem' }}>
              <h2 style={{ fontSize: '1.5rem', fontWeight: 'bold', color: '#111827', marginBottom: '1rem' }}>
                4. Seus Direitos
              </h2>
              <p style={{ marginBottom: '1rem' }}>
                Você tem o direito de:
              </p>
              <ul style={{ marginLeft: '1.5rem', marginBottom: '1rem' }}>
                <li style={{ marginBottom: '0.5rem' }}>Acessar suas informações pessoais</li>
                <li style={{ marginBottom: '0.5rem' }}>Corrigir dados incompletos ou incorretos</li>
                <li style={{ marginBottom: '0.5rem' }}>Solicitar a exclusão de seus dados</li>
                <li style={{ marginBottom: '0.5rem' }}>Revogar seu consentimento a qualquer momento</li>
              </ul>
            </section>

            <section style={{ marginBottom: '2rem' }}>
              <h2 style={{ fontSize: '1.5rem', fontWeight: 'bold', color: '#111827', marginBottom: '1rem' }}>
                5. Contato
              </h2>
              <p>
                Para exercer seus direitos ou esclarecer dúvidas sobre nossa política de privacidade, entre em contato conosco através do email: 
                <strong style={{ color: '#2563eb' }}> privacidade@beno.com.br</strong>
              </p>
            </section>
          </div>

          {/* Back Button */}
          <div style={{ textAlign: 'center', marginTop: '3rem' }}>
            <button 
              onClick={onBack || (() => window.history.back())}
              style={{
                background: 'linear-gradient(45deg, #2563eb, #1d4ed8)',
                color: 'white',
                border: 'none',
                padding: '0.75rem 2rem',
                borderRadius: '0.5rem',
                fontSize: '1rem',
                fontWeight: '600',
                cursor: 'pointer',
                transition: 'all 0.3s ease'
              }}
            >
              ← Voltar
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;